var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconBed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.8,
  d: "M2.223 10.315h-.4v1.624a.645.645 0 1 0 1.29 0v-1.624h-.89ZM14.469 10.315h-.4v1.624a.645.645 0 0 0 1.29 0v-1.624h-.89ZM14.957 10.298h.4V9.22c0-.929-.753-1.682-1.681-1.682H3.505c-.93 0-1.682.753-1.682 1.682v1.078h13.134ZM13.411 7.476V5.874c0-.708-.574-1.282-1.282-1.282H5.08c-.708 0-1.282.574-1.282 1.282v1.602"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.8,
  d: "M7.962 7.477v-.962a.32.32 0 0 0-.32-.32H5.559a.32.32 0 0 0-.32.32v.962M11.97 7.477v-.962a.32.32 0 0 0-.32-.32H9.567a.32.32 0 0 0-.32.32v.962"
})));
export default SvgIconBed;